import { SuggestionPlugin } from '@alpod-ai-writer/plate-plugins/suggestion/react';
import { cn } from '@udecode/cn';
import { useEditorPlugin, usePluginOption } from '@udecode/plate/react';
import { PencilLineIcon } from 'lucide-react';
import React from 'react';

import { ToolbarButton } from '../common/toolbar.component';

export function SuggestionToolbarButton() {
    const { setOption } = useEditorPlugin(SuggestionPlugin);
    const isSuggesting = usePluginOption(SuggestionPlugin, 'isSuggesting');
    return (
        <ToolbarButton
            className={cn(isSuggesting && 'bg-blue-300 hover:bg-blue-400')}
            onClick={() => setOption('isSuggesting', !isSuggesting)}
            onMouseDown={(e) => e.preventDefault()}
            tooltip={isSuggesting ? 'Vypnout režim návrhů' : 'Navrhovat změny'}
        >
            <PencilLineIcon />
            <span className='hidden xl:inline-block'>Navrhovat změny</span>
            <span className='inline-block lg:hidden'>Navrhovat</span>
        </ToolbarButton>
    );
}
